import {forwardRef, SVGProps} from "react";
import {Select as SharedSelect, SelectType} from "@bounce/shared/ui";
import {IconChevronUp} from "@bounce/shared/ui/assets";
import {outlinedInputSx} from "./inputStyles";

const DropdownIcon = ({style, ...props}: SVGProps<SVGSVGElement>) => (
  <IconChevronUp
    {...props}
    style={{...style, width: 20, height: 20}}
  />
);

export const Select = forwardRef<HTMLDivElement, SelectType>(({sx, IconComponent, ...props}, ref) => (
  <SharedSelect
    ref={ref}
    IconComponent={IconComponent ?? DropdownIcon}
    sx={{
      ...outlinedInputSx,
      "& .MuiSelect-icon": {
        top: "50%",
        transform: "translateY(-50%) rotate(180deg)",
        transition: "transform 0.25s ease-in-out",
      },
      "& .MuiSelect-iconOpen": {
        transform: "translateY(-50%) rotate(0deg)",
      },
      ...sx,
    }}
    {...props}
  />
));
